<template>
  <div>
    <sc-form
      autocomplete="off"
      ref="carrierForm">

        <template slot="fields" slot-scope="{ fields }">
          <div class="mainContent">
            <div class="mainContent__paragraphs">
              <p>
                Esses são os dados que a transportadora irá utilizar para atualizar as ocorrências do pedido, iremos enviar para o parceiro realizar a configuração, sinta-se a vontade para reforçar.
              </p>
            </div>

          <div class="mainContent__data">

            <div class="mainContent__token">
              <strong> TOKEN(lp-api-key): </strong>
              <sc-field>
                <sc-input class="mainContent__input" :value="token" id="token" readonly expanded/>

                <p class="control">
                  <sc-tooltip label="Copiar" position="is-bottom">
                    <sc-button
                      id="copy-target-content"
                      theme="primary"
                      icon="copy"
                      :text="copyText"
                      :disabled="!!copyText"
                      data-clipboard-target="#token"/>
                    </sc-tooltip>
                  </p>
              </sc-field>

            </div>

            <div class="mainContent__andress">
              <strong> Endereço do SFTP: </strong>
              <sc-field>
                <sc-input class="mainContent__input" :value="andress" id="andress" readonly expanded/>

                <p class="control">
                  <sc-tooltip label="Copiar" position="is-bottom">
                    <sc-button
                      id="copy-target-content"
                      theme="primary"
                      icon="copy"
                      :text="copyText"
                      :disabled="!!copyText"
                      data-clipboard-target="#andress"/>
                    </sc-tooltip>
                  </p>
              </sc-field>
            </div>


            <div class="mainContent__user">
              <strong> Usuário do SFTP: </strong>
              <sc-field>
                <sc-input class="mainContent__input" :value="userFtp" id="userFtp" readonly expanded/>

                <p class="control">
                  <sc-tooltip label="Copiar" position="is-bottom">
                    <sc-button
                      id="copy-target-content"
                      theme="primary"
                      icon="copy"
                      :text="copyText"
                      :disabled="!!copyText"
                      data-clipboard-target="#userFtp"/>
                    </sc-tooltip>
                  </p>
              </sc-field>
            </div>

            <div class="mainContent__password">
              <strong> Senha do SFTP: </strong>
              <sc-field>
                <sc-input class="mainContent__input" :value="password" id="password" readonly/>

                <p class="control">
                  <sc-tooltip label="Copiar" position="is-bottom">
                    <sc-button
                      id="copy-target-content"
                      theme="primary"
                      icon="copy"
                      :text="copyText"
                      :disabled="!!copyText"
                      data-clipboard-target="#password"/>
                    </sc-tooltip>
                  </p>
              </sc-field>
            </div>
          </div>

          <div class="mainContent__folders">
            <h1><strong> Pastas criadas: </strong></h1>
            <h2>/NOTFIS</h2>
            <h2>/OCOREN</h2>
            <h2>/CTE</h2>
            <h2>/CONEMB</h2>
            <h2>/DOCCOB</h2>
          </div>
        </div>
        <help-button/>
        </template>

        <template slot="actions" slot-scope="{ isValid }">
          <sc-button
            text="Voltar"
            theme="default"
            type="button"
            @click="setActiveStep(2)"/>
          <sc-button
            text="Próximo"
            theme="primary"
            @click="navigateNext"
            type="button"/>
        </template>
      </sc-form>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import {
    ScButton,
    ScForm,
    ScField,
    ScIcon,
    ScInput,
    ScTooltip,
  } from '@intelipost-js/secure-components';
  import { Clipboard } from '@intelipost-js/secure-providers';

  import HelpButton from '../help-button/HelpButton.vue';

  const { mapState, mapMutations } = createNamespacedHelpers('integrations/integrationsStep');

  export default {
    name: 'sc-data-carrier',
    data() {
      return {
        token: '1234984-djuoiaj-1654985f-fa1654f1a',
        andress: 'edi-prd-v1.intelipost.com.br',
        userFtp: 'User-teste',
        password: '123',
        copyText: '',
      };
    },
    computed: {
      ...mapState([
        'activeStep',
      ]),
    },
    methods: {
      ...mapMutations([
        'setActiveStep',
      ]),
      navigateNext() {
        this.setActiveStep(4);
      },
    },
    mounted() {
      this.clipboard = new Clipboard('#copy-target-content');
      this.clipboard.on('sucess', () => {
        this.copyText = 'Copiado para sua área de transferência!';
        setTimeout(() => {
          this.copyText = null;
        }, 1000);
      });
    },
    destroyed() {
      if (this.clipboard) {
        this.clipboard.listener.destroy();
      }
    },
    components: {
      ScButton,
      ScForm,
      ScField,
      ScIcon,
      ScInput,
      ScTooltip,
      HelpButton,
    },
  };
</script>

<style lang='scss' scoped>
  .mainContent {
    display: flex;
    gap: 50px;
    flex-direction: column;

    &__clipboard {
      display: flex;
      align-items: center;
      gap: 20px;

      h1 {
        font-weight: bold;
      }
    }

    &__input {
      width: 20rem;
    }

    &__data {
      display: flex;
      gap: 20px;
      flex-direction: column;
      width: 500px;

      & > * {
        display: flex;
        align-items: center;
        gap: 10px;
        justify-content: space-between;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/sc-data-carrier/ScDataCarrier.vue